export const QueryParametersConstants = {
  KissflowId: "instance_id",
};